import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["link", "button", "status"];

  async copy() {
    this.buttonTarget.disabled = true;
    this.statusTarget.textContent = "";

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(this.linkTarget.value);
      } else {
        this.linkTarget.focus();
        this.linkTarget.select();
        if (!document.execCommand("copy")) throw new Error("Copy unavailable");
      }
      this.statusTarget.textContent = "Link copied.";
    } catch (_) {
      this.linkTarget.focus();
      this.linkTarget.select();
      this.statusTarget.textContent = "Could not copy. Select and copy the link above.";
    } finally {
      this.buttonTarget.disabled = false;
    }
  }
}
